/* eslint-disable react/prop-types */
import { Button, Modal } from "react-bootstrap"

const DeleteModal = ({ showDeleteModal, handleCancelDelete, currentUser, handleConfirmDelete }) => {
    return (
        <Modal
            show={showDeleteModal}
            onHide={handleCancelDelete}
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Deactivate User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    Are you sure you want to deactivate{" "}
                    <strong>
                        {currentUser?.firstName} {currentUser?.lastName}?
                    </strong>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn-sm"
                    variant="secondary"
                    onClick={handleCancelDelete}>
                    Cancel
                </Button>
                <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleConfirmDelete}>
                    Deactivate
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteModal
